import { render, staticRenderFns } from "./wtGetTheApp.component.vue?vue&type=template&id=65a841dc&scoped=true&"
import script from "./wtGetTheApp.component.vue?vue&type=script&lang=js&"
export * from "./wtGetTheApp.component.vue?vue&type=script&lang=js&"
import style0 from "./wtGetTheApp.component.vue?vue&type=style&index=0&id=65a841dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a841dc",
  null
  
)

export default component.exports